export default "__VITE_ASSET__CxphF8Q3__"